import { render, staticRenderFns } from "./PxfDescription.vue?vue&type=template&id=6bb1f9b0&scoped=true&"
import script from "./PxfDescription.vue?vue&type=script&lang=js&"
export * from "./PxfDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb1f9b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb1f9b0')) {
      api.createRecord('6bb1f9b0', component.options)
    } else {
      api.reload('6bb1f9b0', component.options)
    }
    module.hot.accept("./PxfDescription.vue?vue&type=template&id=6bb1f9b0&scoped=true&", function () {
      api.rerender('6bb1f9b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/fragments/mobile/PxfDescription.vue"
export default component.exports